import { useEffect, useState } from "react";

import { useRestClientContext } from "../contexts/RestClientContext";
import { useTeamContext } from "../contexts/TeamContext";
import Client from "../rest/Client";
import { PropertyResponse } from "../rest/Property";
import { Property } from "../rest/responses/Property";
import { LegacyPropertyQuery } from "../rest/IClient";

interface TableProperties {
	loading: boolean;
	properties?: (PropertyResponse | Property)[];
}

// NB: Returns either the selected properties, or will fetch properties based on the filters selected
export default function useTableProperties(
	selected: (PropertyResponse | Property)[],
	query?: LegacyPropertyQuery
): TableProperties {
	const client: Client = useRestClientContext();
	const team = useTeamContext();

	const [loading, setLoading] = useState(true);
	const [properties, setProperties] = useState();

	useEffect(() => {
		if (selected.length) return;

		const controller = new AbortController();

		setProperties(undefined);
		setLoading(true);

		client
			.fetchTeamProperties(
				team,
				{
					...query,
					page_size: 0xffffffff,
				},
				controller.signal
			)
			.then((response: Response) => response.json())
			.then((json: any) => {
				setProperties(json.entries);
				setLoading(false);
			});

		return () => controller.abort("Query or properties changed");
	}, [selected, query, client, team]);

	if (selected.length) {
		return {
			loading: false,
			properties: selected,
		};
	}

	return {
		loading,
		properties,
	};
}
